import { OnInit, AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { Router } from '@angular/router';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'path-shared/services/notification/notification.service';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { LegislacioService } from '../services/legislacions-service.service';
import { PermissionDialogComponent } from 'path-shared/components/permission-dialog/permission-dialog.component';
import { LegislacioFilter } from '../models/legislacio-filter';
import { Builder } from 'path-shared/models/builder';
import { LegislacionsTableComponent } from '../components/legislacions-table/legislacions-table.component';
import { LegislacionsFilterComponent } from '../components/legislacions-filter/legislacions-filter.component';
import { LegislacionsEditorComponent } from '../components/legislacions-editor/legislacions-editor.component';

@Component({
  selector: 'app-legislacions',
  templateUrl: './legislacions.component.html',
  styleUrls: ['./legislacions.component.scss']
})
export class LegislacionsComponent implements OnInit, AfterViewInit {

  permissionDialogRef: MatDialogRef<PermissionDialogComponent>;
  activeFilters: string[] = [];
  filterData: LegislacioFilter;
  somIdFoo: number;
  tipusMatricules = Array();
  dataDialog: ComponentDialog = Builder.newComponentDialog();

  @ViewChild(LegislacionsTableComponent) legislacioTable: LegislacionsTableComponent;

  constructor(
    private dialog: MatDialog,
    public auth: AuthorizationService,
    private i18n: I18n,
    private not: NotificationService,
    public thisDialogRef: MatDialogRef<LegislacionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
    ) {
      this.filterData = new LegislacioFilter('', '');
      if (data !== undefined) {
        this.dataDialog = data;
      }
    }

  ngOnInit(): void {
    this.auth.UserCanSeePage(this.auth.Pages.Legislacions);
    this.legislacioTable.itemClicked.subscribe(secure_id => {
      this.update(secure_id);
    });
    this.legislacioTable.itemSelected.subscribe(codi => {
      this.thisDialogRef.close(codi);
    });
  }

  ngAfterViewInit() {
    if (!this.dataDialog.isDialog) {
      this.not.titleChange(this.i18n('Legislacions'));
    }
  }

  edit() {
    const idSeleccionat: string = this.legislacioTable.displayedItems['checkedItems'][0];
    this.update(idSeleccionat);
  }

  create() {
    this.update(null);
  }

  update(secure_id: string) {
    const data: ComponentDialog = Builder.newComponentDialog(true, false, secure_id);

    const ref = this.dialog.open(LegislacionsEditorComponent, {
      width: '70%',
      closeOnNavigation: false,
      autoFocus: true,
      data: data
    });

    ref.afterClosed().subscribe(updated => {
      if (updated) { this.legislacioTable.load(); }
    });
  }

  refresh() {
    this.legislacioTable.load();
  }

  onFilterClicked() {
    const ref = this.dialog.open(LegislacionsFilterComponent, {
      width: '50%',
      closeOnNavigation: false,
      autoFocus: true,
      data: {
        'filter': this.legislacioTable.filter
      }
    });

    ref.componentInstance.notify.subscribe((filter: LegislacioFilter) => {
      this.legislacioTable.filter.set(filter);
      this.legislacioTable.load();
    });
  }

  onRowSelected(somid) {
    this.update(somid);
  }

  generateExcel() {
    this.legislacioTable.generateExcel();
  }

}
